<template>
  <div class="selection">
    <button
      type="button"
      @click="changeTypeTo('wildcard')"
      :class="selectedProductType === 'wildcard' ? 'selected' : ''"
    >
      Wildcard
    </button>
    <button
      type="button"
      @click="changeTypeTo('adoption')"
      :class="selectedProductType === 'adoption' ? 'selected' : ''"
    >
      Adopt
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'EcommerceFilterProductType',
  components: {},
  computed: {
    ...mapState({
      selectedProductType: (state) => state.ecommerce.selectedProductType,
      selectedCategories: (state) => state.ecommerce.selectedCategories,
    }),
  },
  methods: {
    changeTypeTo(value) {
      if (this.selectedProductType !== value) {
        this.$store.dispatch('updateSelectedProductType', value);
        this.$store.dispatch('updateSelectedCategories', []);
        this.$store.dispatch('updateIsSeeingAll', false);
      }
    },
  },
};
</script>

<style scoped>
.selection {
  display: flex;
  flex-direction: row;
}

button {
  cursor: pointer;
  background-color: #ededed;
  border: 1px solid #d1d1d1;
  box-sizing: border-box;
  border-radius: 0;
  width: 150px;
  height: 50px;
}

@media only screen and (max-width: 64em) {
  button {
    width: 120px;
  }
}

.selected {
  background-color: #d1d1d1;
}

@media only screen and (max-width: 40em) {
  button {
    width: 100%;
    height: 60px;
  }

  .selection {
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// ProductType.vue?c4295144